import React from "react";
import styles from "./SpeakerComponent.module.scss";
import TriSpeaker from "./TriSpeaker";
import DuoSpeaker from "./DuoSpeaker";

interface WebinarCardProps {
  Webinar?: WebinarUI;
}
const WebinarSpeakerComponent = ({ Webinar }: WebinarCardProps) => {
  const speakerCount = Webinar?.Speaker?.length || 0;
  return (
    <div className={styles.WebinarBaner}>
      {speakerCount===2 &&  <DuoSpeaker Webinar={Webinar}/>}
      {speakerCount===3 && <TriSpeaker Webinar={Webinar}/>}
      {speakerCount === 0 && (
        <p className={styles.NoSpeakerMessage}>No speakers available.</p>
      )}
      {speakerCount > 3 && (
        <p className={styles.MultipleSpeakersMessage}>
          More than 3 speakers are not supported.
        </p>
      )}
    </div>
  );
};

export default WebinarSpeakerComponent;
